import { sha256 } from '@noble/hashes/sha256';
import { ripemd160 } from '@noble/hashes/ripemd160';
import { bech32 } from '@scure/base';
import { GONKA_BECH32_PREFIX } from './config.js';
/**
 * Convert a compressed secp256k1 public key to a Gonka bech32 address.
 * Steps: pubkey -> SHA256 -> RIPEMD160 -> bech32 with "gonka" HRP.
 */
export function pubkeyToAddress(pubkey) {
    if (pubkey.length !== 33) {
        throw new Error(`Compressed pubkey must be 33 bytes, got ${pubkey.length}`);
    }
    const hash160 = ripemd160(sha256(pubkey));
    const words = bech32.toWords(hash160);
    return bech32.encode(GONKA_BECH32_PREFIX, words);
}
/**
 * Validate a Gonka bech32 address. Checks prefix, checksum, and length.
 */
export function validateGonkaAddress(address) {
    if (typeof address !== 'string' || address.length !== 44) {
        return false;
    }
    if (!address.startsWith('gonka1')) {
        return false;
    }
    try {
        const decoded = bech32.decode(address);
        return decoded.prefix === GONKA_BECH32_PREFIX && decoded.words.length > 0;
    }
    catch {
        return false;
    }
}
/**
 * Shorten an address for UI display: first 10 + "..." + last 6 chars.
 */
export function shortenAddress(address) {
    if (address.length <= 20)
        return address;
    return `${address.slice(0, 10)}...${address.slice(-6)}`;
}
//# sourceMappingURL=address.js.map